import {RefObject, useEffect, useRef} from "react";

interface ScrollableModel {
    events: {
        on(event: "scrollIntoView", handler: () => void): () => void;
    };
}

interface UseScrollIntoViewOptions {
    behavior?: ScrollBehavior;
    block?: ScrollLogicalPosition;
    inline?: ScrollLogicalPosition;
}

export function useScrollIntoView<TElement extends HTMLElement = HTMLElement>(
    model: ScrollableModel,
    options?: UseScrollIntoViewOptions,
): RefObject<TElement | null> {
    const ref = useRef<TElement>(null);

    useEffect(() => {
        const unsubscribe = model.events.on("scrollIntoView", () => {
            ref.current?.scrollIntoView({
                behavior: options?.behavior ?? "smooth",
                block: options?.block ?? "center",
                inline: options?.inline ?? "nearest",
            });
        });

        return () => {
            unsubscribe();
        };
    }, [model, options]);

    return ref;
}
